import { imagesHelper, rectsHelper, issueFieldHelper } from './commons.helper.js'
import { statusHelper, revisionHelper } from './editorial.helper.js'
import { fashionMetadataAlwaysEnabled } from './instagram.helper.js'

const defaultHelper = () => (publication, remove = false) => {
  if(remove) return publication

  let metadataWithFlags = { ...publication.metadata }
  Object.keys(metadataWithFlags).forEach(key => ( metadataWithFlags[key].enabled = true ))
  const metadataFiller = {
    default: { enabled: false },
    fashion: { enabled: false },
    event: { enabled: false },
    interview: { enabled: false },
    celebrity: { enabled: false },
    family: { enabled: false },
    collaboration: { enabled: false },
    finance: { enabled: false },
    mention: { enabled: false },
    physical_media_present: { enabled: false }
  }
  metadataWithFlags = { ...metadataFiller, ...metadataWithFlags }
  return { ...publication, metadata: metadataWithFlags }
}

const acceptedHelpers = {
  'default': defaultHelper,
  'status': statusHelper,
  'revision': revisionHelper,
  'images': imagesHelper,
  'rects': rectsHelper,
  'issue': issueFieldHelper,
  'ensure-fashion-metadata': fashionMetadataAlwaysEnabled
}

const appendHelpers = (publication, repository, helpers) => {
  [...helpers, 'default'].forEach(helper => {
    const helperFunc = acceptedHelpers[helper]
    if(helperFunc)
      publication = helperFunc(repository)(publication)
  })

  return publication
}

const removeHelpers = (publication) => {
  Object
    .keys(acceptedHelpers)
    .forEach(key => publication = acceptedHelpers[key]({})(publication, true))
  return publication
}

export { appendHelpers, removeHelpers }